class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverOpenDelay = null;
    this.hoverCloseDelay = null;

    // Add hover behavior on desktop
    if (window.matchMedia('(min-width: 990px)').matches) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

      // On desktop, hover handles opening the mega menu, so a click on the
      // top-level item navigates to its collection instead of toggling.
      this.mainDetailsToggle.querySelector('summary').addEventListener('click', (e) => {
        if (!window.matchMedia('(min-width: 990px)').matches) return;

        // Let modifier-clicks fall through to the anchor (open in new tab/window).
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;

        e.preventDefault();
        const topLink = e.currentTarget.querySelector('[data-mega-menu-top-link]');
        const href = topLink?.getAttribute('href');
        if (href && href !== '#') window.location.assign(href);
      });
    }
  }

  onMouseEnter() {
    clearTimeout(this.hoverCloseDelay);
    this.hoverOpenDelay = setTimeout(() => {
      // Close other open mega menus
      document.querySelectorAll('header-menu details[open]').forEach((detail) => {
        if (detail !== this.mainDetailsToggle) {
          detail.removeAttribute('open');
          detail.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        }
      });
      this.open();
    }, 80);
  }

  onMouseLeave() {
    clearTimeout(this.hoverOpenDelay);
    this.hoverCloseDelay = setTimeout(() => {
      this.close();
    }, 150);
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
